export default "/images/vendor/flag-icon-css/flags/4x3/gn.svg?bf5b087387ce93eddfacb5f5ff5c656d";